/** 从定邀或会议嘉宾列表行读取嘉宾备注 */
export function getGuestRemarksFromRecord(record) {
    return record?.remarks ?? record?.guestsEntity?.remarks ?? '';
}
